export const GENERIC_MESSAGES = {
    GET: {
        ERROR_SEARCH: "¡Ha ocurrido un error al realizar la búsqueda!"
    },
}

export const REPORT_MESSAGES = {
    GET: {
        ERROR_PARAMETERS: "¡Ha ocurrido un error cargando los parametros del reporte!",
        ERROR_QUERY_REPORTS: "¡Ha ocurrido un error obteniendo las consultas!",
        ERROR_REPORTS: "¡Ha ocurrido un error al obtener los reportes!",
        ERROR_LATEST_REPORTS: "¡Ha ocurrido un error al obtener los reportes recientes!",
    },
    CREATE: {
        REPORT: "¡El reporte ha sido guardado exitosamente!",
    },
    GENERATE: {
        REPORT: "¡El reporte se está generando, revisar sección de tareas!",
    },
    UPDATE: {
        ERROR_FAVORITE: "¡Ha ocurrido un error al actualizar el reporte!"
    }
}

export const BOARD_MESSAGES = {
    CREATE: {
        BOARD: "¡El tablero ha sido creado exitosamente!",
    },
    GET: {
        ERROR_SOURCE_BOARD: "¡Ha ocurrido un error obteniendo el tablero!",
        ERROR_BOARDS: "¡Ha ocurrido un error al obtener los tableros!",
        ERROR_EMBED_BOARD: "¡Ha ocurrido un error al obtener la información del tablero!",
        ERROR_RECENT_BOARDS: "¡Ha ocurrido un error al obtener los tableros recientes!"
    },
    UPDATE: {
        ERROR_FAVORITE: "¡Ha ocurrido un error al actualizar el tablero!"
    },
    DELETE: {
        QUESTION: "Desea eliminar el tablero seleccionado?",
        BOARD: "¡El tablero ha sido eliminado correctamente!"
    }
}

export const TASK_REPORT_MESSAGES = {
    GET: {
        ERROR_REPORTS: "¡Ha ocurrido un error al cargar la información de las tareas del reporte!"
    },
}

export const PARAMETERS_LIST_MESSAGES = {
    GET: {
        ERROR_PARAMETERS: "¡Ha ocurrido un error al obtener los parametros lista!"
    },
    CREATE: {
        PARAMETER_LIST: "¡El parametro lista ha sido guardado exitosamente!",
    },
}

export const USER_MESSAGES = {
    GET: {
        ERROR_USER: "¡Ha ocurrido un error al realizar la búsqueda!"
    },
    CREATE: {
        USER: "¡El usuario fue guardado correctamente!"
    },
    UPDATE: {
        USER: "¡El usuario fue actualizado correctamente!",
        PROFILE: "¡Se ha actualizado correctamente la información del usuario!"
    },
}

export const REPORT_GROUP_MESSAGES = {
    GET: {
        ERROR_REPORT_GROUP: "¡Ha ocurrido un error al obtener los grupos de reportes!",
        ERROR_QUERY_USERS: "¡Ha ocurrido un error obteniendo los usuarios!"
    },
    CREATE: {
        REPORT_GROUP: "¡El grupo de reportes ha sido guardado exitosamente!",
    },
    UPDATE: {
        REPORT_GROUP_USER: "¡El usuario fue agregado exitosamente!"
    },
    DELETE: {
        QUESTION: "¿Desea eliminar el usuario seleccionado?",
        REPORT_GROUP_USER: "¡El usuario fue eliminado exitosamente!"
    }
}


export const GENERIC_ERROR = "¡Ha ocurrido un error inesperado!";

export const CLOSE_SESSION = "¿Deseas cerrar la sesión activa?";

export const FIREBASE_MESSAGES = {
    ERROR_EMAIL: "¡El correo ingresado no esta registrado!",
    ERROR_INVALID_EMAIL: "¡El correo ingresado no es valido!",
    ERROR_PASSWORD: "!La contraseña actual es incorrecta!",
    ERROR_EMAIL_AND_PASSWORD: "¡El correo o la contraseña no son válidos!",
    ERROR_USER_DISABLED: "¡La cuenta del usuario ingresado ha sido desactivada!",
    ERROR_EXPIRED_OOB_CODE: "¡El código para restablecer la contraseña ha expirado!",
    ERROR_INVALID_OOB_CODE: "¡El código para restablecer la contraseña es inválido!",
    ERROR_INVALID_REFRESH_TOKEN: "¡La sesión actual ha caducado!",
}

export const RESET_PASSWORD = "¡Se ha enviado el correo para restablecer tu contraseña!";
export const CHANGE_PASSWORD = "¡Se ha actualizado tu contraseña exitosamente!";
